import { LoaderFunctionArgs } from 'react-router-dom'
import { protectedLoader } from './protectLoader'
import {
  CUSTOMER_ADMIN,
  CUSTOMER_SUPPORT,
  DISTRIBUTOR_ADMIN,
  DISTRIBUTOR_SUPPORT,
  HOLDER,
  PORTAL_ADMIN,
  PORTAL_SUPPORT,
} from '.'
import { lazyRoute } from '../utils/lazyRoute'

const livoxUserRoutes = [
  {
    path: '/my-users',
    lazy: lazyRoute(() => import('../pages/Portal/MyLivoxUsers')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [HOLDER],
      }),
  },
  {
    path: '/livox-users',
    lazy: lazyRoute(() => import('../pages/Portal/LivoxUsers')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
        ],
      }),
  },
  {
    path: '/my-assessments',
    lazy: lazyRoute(() => import('../pages/Portal/MyAssessments')),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [HOLDER],
      }),
  },
  {
    path: '/assessment/:userId',
    lazy: lazyRoute(
      () => import('../pages/Portal/MyAssessments/InfoAssessments'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [
          PORTAL_ADMIN,
          PORTAL_SUPPORT,
          DISTRIBUTOR_ADMIN,
          DISTRIBUTOR_SUPPORT,
          CUSTOMER_ADMIN,
          CUSTOMER_SUPPORT,
          HOLDER,
        ],
      }),
  },
  {
    path: '/new-assessment/:userId',
    lazy: lazyRoute(
      () => import('../pages/Portal/MyAssessments/NewAssessments'),
    ),
    loader: (args: LoaderFunctionArgs) =>
      protectedLoader(args, {
        allowedRoles: [HOLDER],
      }),
  },
]

export default livoxUserRoutes
